export default __webpack_public_path__ + "static/media/AI Concierge.b12b360c.svg";